export default "assets/images/texture-menu-18807ac3.jpg";